import React, { useEffect, useState } from 'react';
import {
  ActivityIndicator, ImageBackground, ScrollView, View,
} from 'react-native';
import { useSelector } from 'react-redux';

import leths_back from '../../../assets/images/leths_back.png';
import { appColors } from '../../../assets/styles/global';
import { AppHeader } from '../../../components/common';
import { AppButton, AppText } from '../../../components/form';
import { API } from '../../../service/api';
import styles from './styles';

const PromItem = ({ label, coins }) => (
  <AppButton style={styles.viewPromItem}>
    <>
      <View style={[styles.viewPromItemTextContainer, styles.viewPromItemTextContainer]}>
        <AppText size="bold" style={styles.textPromItem}>{label}</AppText>
      </View>
      <View style={styles.viewCentered}>
        <AppText style={[styles.textPromItem, styles.textPromItemBigger]}>{coins}</AppText>
        <AppText size="bold" style={[styles.textPromItem, styles.textPromItemSmaller]}>MOEDAS</AppText>
      </View>
    </>
  </AppButton>
);

const ClaimHistory = ({ navigation }) => {
  const { workerData } = useSelector((state) => state.worker);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.post('/search/resgate_moeda', {
      where: `id_colaborador = '${workerData.id_colaborador}'`,
    }).then((result) => {
      setData(result.data.data);
      return setLoading(false);
    });
  }, []);

  return (
    <ImageBackground source={leths_back} style={styles.viewBase}>
      <AppHeader title="Histórico" hasBack navigation={navigation} />
      <View style={styles.content}>
        {loading ? <ActivityIndicator size="large" color={appColors.primary} /> : (
          <>
            {data.length === 0 && (
            <AppText>Sem itens resgatados.</AppText>
            )}
            <ScrollView style={styles.scrollview}>
              {data.map((item) => (
                <PromItem key={item.seq} label={item.historico} coins={item.valor_resgate} />

              ))}
            </ScrollView>
          </>
        )}
      </View>
    </ImageBackground>
  );
};

export default ClaimHistory;
